import { useQuery } from 'react-query';
import { request } from '../../../config/helpers/axios-instance';

const useOrderGuardrails = (orderId) =>
    useQuery(
        ['order-guardrails', orderId],
        () => request({ url: `userOrder/admin/guardrails/${orderId}`, method: 'GET' }),
        { enabled: !!orderId, refetchOnWindowFocus: false }
    );

export default useOrderGuardrails;
